<template>
  <div>
    <div class="schedule">
      <div class="timeline-view hidden-mobile" :class="{ 'zoom-1x' : selectedZoomLevel === 1, 'zoom-2x' : selectedZoomLevel === 2, 'drawer-open': showForecast }">
        <statistics-overlay ref="statsOverlay"></statistics-overlay>
        <ScheduleDayGrid
          :selectedDate="selectedDate"
          :zoomLevel="selectedZoomLevel" />

        <div class="meta-rows">
          <div :class="['row', 'controls-row', simulation && 'simulation']">
            <div class="viewport-toggle" style="width:320px; height: 40px;">
              <div class="control-button-toggle">
                <a
                  @click="setGrouping('EMPLOYEE')"
                  class="control-button"
                  :class="{ 'is-active' : (groupBy === 'EMPLOYEE') }"
                >Medarbejdere</a>
              </div>
            </div>
            <div class="viewport-divider"></div>
            <div class="viewport-controls">
              <GroupDropdown
                :sourceList="filteredGroups"
                @selectionChanged="filterGroups"
                :keyPropertyName="(o) => o.id"
                :displayPropertyName="(o) => o.title"
                :selectedValue="groupFilter"
                />
            </div>
            <div class="viewport-divider"></div>
            <div class="viewport-controls">
              <div class="viewport-toggle" style="width:150px; height:30px; padding:0; display:flex;display: none;">
                <b-switch v-model="simulation">{{ simulation ? 'Simulering' : 'Planlægning' }}</b-switch>
              </div>
              <div class="viewport-toggle" style="width:180px; height: 30px; padding:0;" v-if="simulation">
                <div class="control-button-toggle" style="padding: 0px; cursor:pointer;" v-if="groupFilter">
                  <a style="cursor:pointer;" @click="showGroupTemplateSelectionSidebar" class="control-button" :class="{ 'is-active': (groupBy === 'EMPLOYEE') }">
                    Gruppe skabeloner
                  </a>
                </div>
                <div style="padding: 2px;font-weight:bold;width: 250px;" v-if="!groupFilter">
                  Vælg gruppe for at fortsætte
                </div>
              </div>
              <div class="viewport-toggle" style="width:180px; height:30px; padding:0; display:flex; margin-left:50px;" v-if="formGroupTemplate && (isAdmin || currentUser.id === formGroupTemplate.createdBy)">
                <div class="control-button-toggle" style="padding:0px; cursor:pointer; font-size:14px; display:flex;">
                  <a style="cursor:pointer; align-self:center;" @click="editGroupTemplate(formGroupTemplate)" :class="{'is-active': (groupBy === 'EMPLOYEE')}">
                    Redigér valgte skabelon
                  </a>
                </div>
              </div>
              <div class="viewport-toggle" style="width:180px; height: 30px; padding:0;"  
                  v-if="formGroupTemplate && formGroupTemplate.allocations && formGroupTemplate.allocations.length > 0 && (isAdmin || currentUser.id === formGroupTemplate.createdBy)">
              <div class="control-button-toggle" style="padding:0px; cursor:pointer;">
                <a class="success control-button" style="cursor:pointer" @click="applyGroupTemplateAsync">Gør Gældende</a>
              </div>
              </div>
          
          </div>
            
            <div class="viewport-navigation">
              <div class="control-button-toggle">
                <schedule-day-navigator 
                  :selectedDate="selectedDate"
                  @navigate-in-weeks="navigateInWeeks">
                </schedule-day-navigator>                
              </div>
            </div>
          </div>

          <div class="row week-row">
            <div class="filter-input">
              <input type="text" placeholder="Filtrér på opgave titel…"
                v-model="filter"
              >
            </div>
            <div class="row-drawer drawer-label">
              <div class="drawer-inner" @click="openStatistics">
                Simulering statistik
              </div>
            </div>

            <ScheduleWeekGrid
              :selectedDate="selectedDate"
              :zoomLevel="selectedZoomLevel"
              :showOverAllocations="false"/>

          </div>
        </div>

        <div class="schedule-rows" v-if="selectedGroup">
          <div class="project-rows" v-if="filteredEmployees[0]">
            <schedule-row v-for="(employee) of filteredEmployees"
                          v-bind:key="employee.id"
                          :row-data="employee"
                          row-data-key="id"
                          :subrow-data="allocations.filter(q => q.employeeId === employee.id)"
                          subrow-key="id"
                          :view-start-date="viewStartDate"
                          :zoom-level="selectedZoomLevel"
                          :showForecast="showForecast"
                          :show-trash="false">
              <template v-slot:title="{ rowData }">
                <h3>
                  {{ rowData.number }} - {{ employee.name }}
                  <i v-if="employee.area">({{ employee.area }})</i>
                </h3>              
              </template>

              <template v-slot:expandedRows="{ rowData, subrowData, emptyResourceRows }">
                <ScheduleResourceRow v-for="(circle) of employeeCircles(rowData, subrowData, emptyResourceRows)" 
                  :userCanEdit="isAdmin ? isAdmin: currentUser.id == formGroupTemplate.createdBy"
                  :key="circle.id"
                  :projectId="`${circle.id}`"
                  :employeeId="`${rowData.id}`"
                  :title="`${rowData.circleId && rowData.circleId === circle.id ? 'M - ' : ''}${circle.title}`"
                  :projectColor="circle.colorCode"
                  :showForecast="showForecast"
                  :viewStartDate="viewStartDate"
                  :zoomLevel="selectedZoomLevel"
                  @add-allocation="(data) => addAllocation({data, groupFilter})"
                  @resource-clicked="employeeResourceClicked"
                  :mainConfig="{ store: subrowData.filter(q => q.circleId === circle.id), idProperty: 'id', widthProperty: 'allocationSpanInDays', startProperty: 'startDate', classTypeProperty: 'allocationType' }"
                  :otherConfigs="[{ store: findEmployeeOffTime(employee), idProperty: 'id', startProperty: 'startDate', widthProperty: 'allocationSpanInDays', classProperty: 'time-off-frame' }]">

                  <template v-slot:default="{ dataItem }">
                  <div @click="openSidebar(dataItem)" class="side-bar-open">
                      <span class="assignment-label" style="left: 0px;" v-if="dataItem">
                        {{dataItem.allocationType.substring(0,3)}}
                      </span>
                    </div>
                  </template>
                </ScheduleResourceRow>              
              </template>
            </schedule-row>
          </div>
        </div>
      </div>
    </div>

    <group-template-selection-sidebar :selectedGroup="selectedGroup"
                                      :groupFilter="groupFilter"
                                      :fromDate="fromDate"
                                      :toDate="toDate"
                                      v-if="selectedGroup"
                                      @selected-date="(value) => navigateToDate(value)"></group-template-selection-sidebar>

    <group-template-edit-sidebar :groupFilter="groupFilter"
                                 :fromDate="fromDate"
                                 @selected-date="(value) => navigateToDate(value)"></group-template-edit-sidebar>

    <b-loading :is-full-page="isFullPage" :active.sync="loading" :can-cancel="true"></b-loading>
  </div> 

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ApiState from "../enums/APISTATE";
import moment, { ISO_8601 } from 'moment';
import _ from 'lodash'
import ScheduleDayGrid from '../components/scheduler/schedule/ScheduleDayGrid.vue';
import ScheduleWeekGrid from '../components/scheduler/schedule/ScheduleWeekGrid.vue';
import ScheduleRow from '../components/scheduler/schedule/ScheduleRow.vue';
import GroupDropdown from '../components/scheduler/schedule/controls/GroupDropdown.vue';
import ScheduleResourceRow from '../components/scheduler/schedule/ScheduleResourceRow.vue';
import ScheduleDayNavigator from '../components/scheduler/schedule/controls/DayNavigator.vue';
import StatisticsOverlay from '../components/scheduler/schedule/StatisticsOverlay.vue';
import GroupTemplateSelectionSidebar from '../components/sidebar/GroupTemplateSelectionSidebar.vue';
import GroupTemplateEditSidebar from '../components/sidebar/GroupTemplateEditSidebar.vue';
import Repository from '@/repositories/RepositoryFactory';

const groupTemplateRepository = Repository.get('groupTemplateRepository');

export default {
  name: 'disposition-view',
  components: {
    ScheduleDayGrid,
    ScheduleWeekGrid,
    ScheduleRow,
    GroupDropdown,
    ScheduleResourceRow,
    ScheduleDayNavigator,
    StatisticsOverlay,
    GroupTemplateSelectionSidebar,
    GroupTemplateEditSidebar
  },
  data: () => ({ 
    filter: '',
    forecastType: 'FUTURE_PLANNED',
    groupBy: 'EMPLOYEE',
    groupFilter: null,
    groupTemplateValue: null,
    regionFilter: null,
    addResource: null,
    selectedDate: moment.utc().startOf('day').toDate(),
    selectedZoomLevel: 1,
    showForecast: true,
    emptyCircleRows: [],
    regions: [],
    fromDate: moment.utc(new Date()).format('YYYY-MM-DD'),
    toDate: moment.utc(new Date()).format('YYYY-MM-DD'),
    selectedGroup: null,
    isSaturdayWeekendGroup: false,
    isNewGroupTemplate: true,
    simulation: true,
    activeSidebar: '',
    isFullPage: true
  }),
  async mounted() {
    if (localStorage.selectedZoomLevel) {
      this.selectedZoomLevel = parseInt(localStorage.selectedZoomLevel);
    }

    if (localStorage.groupFilter) {
      this.groupFilter = (localStorage.groupFilter === 'null' ? null : localStorage.groupFilter);
    }
    this.setSimulating(this.simulation);

    this.fromDate = moment.utc(this.viewStartDate).format('YYYY-MM-DD');    
    this.toDate = moment.utc(this.viewToDate).format('YYYY-MM-DD');

    await this.$store.dispatch('metadata/initialize');
    await this.loadEmployees();
    await this.getAllGroups();
    await this.loadCircles();
    await this.getHolidays();
    await this.initGroup();
    this.initAllocation({groupFilter: this.groupFilter});
  },
  beforeDestroy() {
    this.setSimulating(false);
  },
  methods: {
    ...mapActions("employees", ["loadEmployees"]),
    ...mapActions("groupStore", ["getAllGroups"]),
    ...mapActions("groupTemplateStore", ["getAllTemplatesForGroup", "createGroupTemplate", "updateGroupTemplate", "setSimulating",  "createGroupTemplateAllocation", "canApplyGroupTemplate"]),
    ...mapActions("circles", ["loadCircles"]), 
    ...mapActions("allocations", ["getTimeOff"]), 
    ...mapActions('groupComments', ['loadGroupComments']),
    ...mapActions("holidayStore", ["getHolidays"]),
    ...mapActions("statisticsStore", ["generateFormGroupTemplate", "initAllocation", "addAllocation", "setFormGroupTemplate", "applyGroupTemplate","showGroupTemplateSelectionSidebar", "showGroupTemplateEditSidebar", "editGroupTemplate", "filterAllocations", "updateManuel"]),
    ...mapActions('entrySidebar', ['entrySidebarOpen','entrySidebarOpenAsync']),
    
      employeeResourceClicked(resource) {
      this.entrySidebarOpen({});
    },
    async applyGroupTemplateAsync() {
      await this.applyGroupTemplate(this.groupFilter);
    },
    dayBetween(start, end){
      const a = moment(start);
      const b = moment(end);
      const totalDays = b.diff(a, 'days');
      return totalDays;
    },
    async openSidebar(entry) {
      console.log(this.formGroupTemplate)
      if(this.isAdmin === false && this.currentUser.id !== this.formGroupTemplate.createdBy){
        return;
      }
      entry.isSimulation = true;
      entry.canEdit = true;
      entry.employee = this.employees.find(o => o.id === entry.employeeId);
      entry.number = entry.employee?.number;
      entry.employeeName = entry.employee?.name;

      await this.entrySidebarOpenAsync(entry).then((response) => {
        if(response.action === "update") {
          const { model } = response;
          if(model) {
            groupTemplateRepository.deleteGroupTemplateAllocation(model);
            // this.allocations = this.allocations.filter(o => o.id !== model.id && !o.isRepeated);
            this.filterAllocations(o => o.id !== model.id && !o.isRepeated);
            model.allocationSpanInDays = this.dayBetween(model.startDate, model.endDateInclusive) + 1;
            // this.addAllocation(model);
            this.addAllocation({data: model, groupFilter: this.groupFilter});
          }
        }
        if(response.action === "delete") {
          const { model } = response;
          if(model) {
            groupTemplateRepository.deleteGroupTemplateAllocation(model);
            // this.allocations = this.allocations.filter(o => o.id !== model.id && !o.isRepeated);
            this.filterAllocations(o => o.id !== model.id && !o.isRepeated);
            this.updateManuel();

          }
        }
      }).catch((error) => console.error(error));
    },
    async initGroup() {
      this.selectedGroup = this.groups.find(o => o.id === this.groupFilter);

      if(!this.selectedGroup) {
        return;
      }
      
      if(!this.selectedGroup.atWorkHolidayWeekdays) {
        this.selectedGroup.atWorkHolidayWeekdays = this.selectedGroup.atWorkWeekSunday;
      }
      
      if(!this.selectedGroup.atWorkHolidayWeekend) {
        this.selectedGroup.atWorkHolidayWeekend = this.selectedGroup.atWorkWeekSunday;
      }
      if(this.selectedGroup) {
        await this.getAllTemplatesForGroup(this.groupFilter);
        await this.loadGroupComments({fromDate: this.fromDate, toDate: this.toDate, forGroup: this.groupFilter});
      }      
    },
    async filterGroups(groupId) {
      this.groupFilter = groupId;      
      localStorage.groupFilter = groupId;
      this.groupTemplateValue = null;
      await this.initGroup();
    },
    async groupTemplateChanged(id) {
      this.groupTemplateValue = id;
      this.formGroupTemplate = this.groupTemplates.find(o => o.id === id);
      if(this.formGroupTemplate) {
        this.formGroupTemplate.fromDate = moment(this.formGroupTemplate.fromDate).format('YYYY-MM-DD');
        this.formGroupTemplate.toDate = moment(this.formGroupTemplate.toDate).format('YYYY-MM-DD');
      }
      if(this.formGroupTemplate && this.groupFilter) {
        await this.getTimeOff({fromDate: this.formGroupTemplate.fromDate, forGroup: this.groupFilter });
      }
      this.isNewGroupTemplate = !this.formGroupTemplate;
      console.log("groupTemplateChanged");
    },
    filterRegions(region) {
      this.regionFilter = region;
      localStorage.regionFilter = region;
    },
    employeeCircles(employee, allocations, emptyResourceRows) {
      var compare = (a, b) => {
          if (a.title < b.title)
            return -1;
          if (a.title > b.title)
            return 1;
          return 0;
        };

      const local = this.circles.filter(o => o.groupId === this.groupFilter && this.groupFilter);
      
      var circleIds = Array.from(allocations, o => o.circleId);
      circleIds = circleIds.concat(this.emptyCircleRows);
      circleIds = circleIds.concat(Array.from(local, o => o.id));

      const employees = this.filteredEmployees;
      if(employees) {
        for(let e of employees) {
          if(e.circleId) {
            const circle = this.circles.find(o => o.id === e.circleId);
            if(circle && circle.title !== "Kreds 0"){
              circleIds.push(e.circleId);
            }            
          }

          if(e.groups && e.groups.find(o => o.groupId === this.groupFilter)){
            const group = e.groups.find(o => o.groupId === this.groupFilter);
            if(group && group.circleId) {
              const circle = this.circles.find(o => o.id === group.circleId);
              if(circle && circle.title !== "Kreds 0"){
                circleIds.push(group.circleId);
              }
            }
          }
        }
      }

      const shiftCircle = this.circles.find(o => o.title === "Bagvagt");

      if(shiftCircle){
        circleIds.push(shiftCircle.id);
      }

      // Distinct
      circleIds = circleIds.filter((value, index, self) => value && self.indexOf(value) === index);
      circleIds = circleIds.filter(o => o); // Remove undefined
      
      let circles = Array.from(circleIds, id => this.circles.find(o => o.id === id)).sort(compare);

      if (circles.findIndex(q => q.id === null) === -1) {
        circles.unshift({
          id: null,
          title: 'Ferie/Fri',
          code: '',
          colorCode: 'black'
        });
      }
      
      circles = circles.filter(o => o); // Remove undefined
      return circles;
    },
    findEmployeeOffTime(employee) {
      return this.allocations.filter(q => q.circleId === null && q.employeeId === employee.id)
    },
    zoomIn() {
      if(this.selectedZoomLevel > 1)
        this.selectedZoomLevel--;
    },
    zoomOut() {
      if(this.selectedZoomLevel < 2)
        this.selectedZoomLevel++;
    },
    navigateInWeeks(numberOfWeeks) {
      this.selectedDate = moment.utc(this.selectedDate).add(numberOfWeeks * 7, 'days').toDate();
      this.navigateInWeeksDebounced();
    },
    navigateToDate(targetDate) {
      console.log(`Navigate to: ${targetDate}`);
      this.selectedDate = targetDate;
    },
    navigateInWeeksDebounced: _.debounce(function () {
      this.loadGroupComments({ 
        fromDate: this.viewStartDate,
        toDate: this.viewToDate,
        forGroup: this.groupFilter
      });
    }, 500),
    formatDate: (date, format) => moment(date).format(format),
    async openStatistics() {
      this.$refs.statsOverlay.toggle();
    },

  },
  computed: {
    ...mapGetters('employees', ['employeeApiState', 'employees']),
    ...mapGetters('groupStore', ['groupApiState','groups']),
    ...mapGetters("groupTemplateStore", ["groupTemplatesApiState", "groupTemplateApiState", "groupTemplates", "groupTemplate"]),
    ...mapGetters('circles', ['circleApiState','circles']),
    ...mapGetters('metadata', ['allocationTypes']),
    ...mapGetters("allocations", ["allocationsTimeOffApiState", "allocationsTimeOff"]),
    ...mapGetters('groupComments', ['groupCommentsApiState','groupComments']),
    ...mapGetters(["currentUser", "isReplacement", "hasEditRights", "isAdmin"]),
    ...mapGetters("holidayStore", ["holidaysApiState", "holidays"]),
    ...mapGetters("statisticsStore", ["allocations", "employeeStatistics", "formGroupTemplate", "statisticsApiState"]),
    loading() {
      return this.employeeApiState !== ApiState.LOADED || 
            this.groupApiState !== ApiState.LOADED || 
            this.circleApiState !== ApiState.LOADED || 
            (this.statisticsApiState !== ApiState.LOADED && this.groupFilter !== null);
    },
    filteredGroups() {
      if(this.groups) {
        let groupsByRegion = this.groups
        .filter(o => o.isRemoved === false)
        .filter(o => !this.regionFilter || o.region === "begge" || o.region === this.regionFilter);

        if(groupsByRegion) {
          return groupsByRegion;
        }
      }
      return this.groups;
    },
    filteredEmployees() {
      if(this.employees) {        
        var compare = (a, b) => {
          console.log("compare");
          let noa = a.orderNumber;
          let nob = b.orderNumber;
          if(a.groups.find(o => o.groupId === this.groupFilter)){
            noa = a.groups.find(o => o.groupId === this.groupFilter).orderNumber;
          }
          if(b.groups.find(o => o.groupId === this.groupFilter)){
            nob = b.groups.find(o => o.groupId === this.groupFilter).orderNumber;
          }

          if(noa < nob){
            console.log(`${a.number} < ${b.number}`);
            return -1;
          }
          
          if(noa > nob){
            console.log(`${a.number} > ${b.number}`);
            return 1;
          }

          if (a.orderNumber < b.orderNumber)
            return -1;
          if (a.orderNumber > b.orderNumber)
            return 1;
          return 0;
        };

        const filterLowerCase = this.filter.toLowerCase();
        var filteredEmployees = this.employees
          .filter((o) =>
            (!this.groupFilter || o.groupId === this.groupFilter|| o.groups.find(f => f.groupId === this.groupFilter)) && 
            (!this.regionFilter || o.region === 'begge' || o.region === this.regionFilter) && 
            (o.name.toLowerCase().includes(filterLowerCase) || o.number.toString().toLowerCase().includes(filterLowerCase)));

        if(this.isReplacement) {
          filteredEmployees = filteredEmployees.filter(o => o.id === this.currentUser.id || o.groups.find(f => f.groupId === this.groupFilter));
        }
        
        filteredEmployees = filteredEmployees.sort(compare);

        if(filteredEmployees) {          
          return filteredEmployees;
        }
      }

      return this.employees;
    },
    dispositions() {
      if (this.allocationsTimeOff && !this.allocations){
        return this.allocationsTimeOff;
      }
      return this.allocations;
    },
    canZoomIn() {
      return this.selectedZoomLevel === 1;
    },
    canZoomOut() {
      return this.selectedZoomLevel === 2;
    },
    selectedWeekNumber() {
      return moment.utc(this.selectedDate).week();
    },
    viewStartDate() {      
      var startDate = moment.utc(this.selectedDate);
      startDate = startDate.add(-startDate.isoWeekday() + 1, 'days');
      return startDate.toDate();
    },
    viewToDate() {      
      return moment(this.viewStartDate).add(this.selectedZoomLevel * 8, 'weeks').toDate();
    },
    latestUpdateTextFormGroupTemplate() {
      if (this.formGroupTemplate) {
        const duration = moment().diff(moment(this.formGroupTemplate._LatestUpdate), "milliseconds");
        const durationText = duration > 0 ? moment.duration(duration).humanize() : '';
  
        return `Opdateret ${durationText} siden af ${this.formGroupTemplate?._UpdatedByName}`;
      }
      return '';
    },    
  },
  watch: {
    isSaturdayWeekendGroup(newValue) {
      this.formGroupTemplate.isSaturdayWeekendGroup = newValue;
    },
    'simulation'(newValue) {
      this.setSimulating(newValue);
    }
  }  
}
</script>

<style lang="scss">
@import "@/components/scheduler/styles/scheduler";
</style>

<style lang="scss" scoped>
.schedule {
  overflow-y: auto;

  .row.controls-row {
    transition-duration: .3s;
  }
  .row.controls-row.simulation {
    background-color: rgb(216, 180, 82);
    transition: .3s background-color ease-in 0s;
  }
}

.button .icon:first-child:last-child {
  margin: 6px 5px 0 -5px;
}
.side-bar-open {
  height: 90%; 
  width: 90%;
}

.success{
  background: white;
  border-color: #0099d9;
  color: #0099d9;
}
.success:active {
   background: white;
  border-color: #0099d9;
  color: #0099d9;
}
</style>
